module.exports = __webpack_public_path__ + "img/error.c61a8937.png";